import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from '@angular/router';

import { ClaimsService } from '@core/authentication/claims.service';
import { Claims } from '@core/authentication/claims';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private readonly claimsService: ClaimsService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const requiredRole = route.data.requiredRole as Claims.UserRoles;
    if (requiredRole) {
      return this.claimsService.userRole === requiredRole;
    }

    return false;
  }
} 